import React from 'react'

import CreatePartnershipForm from './CreatePartnershipForm'
import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'

import useAdditionalPartnershipsData from '../hooks'

import { PARTNERSHIP_CREATE } from '../../../../../constants/forms'

const CreatePartnership = () => {
  const isInitialDataLoading = useAdditionalPartnershipsData(PARTNERSHIP_CREATE)

  return (
    <FormDrawerWrapper
      formName={PARTNERSHIP_CREATE}
      isFormLoading={isInitialDataLoading}
      openButtonText="Create a new partnership"
      title="Create a partnership"
      SkeletonFormComponent={SkeletonSingleSectionForm}
    >
      <CreatePartnershipForm />
    </FormDrawerWrapper>
  )
}

export default CreatePartnership
